import React from "react";
import { useTranslation } from "react-i18next";

import { NotificationDescriptionProps } from "./types";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import BaseProgressBar from "@/components_v2/ProgressBars/BaseProgressBar";

import "./styles.css";

export const NotificationDescription = ({
  filename,
  descriptionKey,
  className,
  progress,
}: NotificationDescriptionProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={`notification-container flex flex-col gap-200 body-m-regular ${className}`}
    >
      <div>{t(descriptionKey)}</div>
      <div className="flex flex-col gap-100">
        <span>{filename}</span>
        {progress !== undefined ? (
          <BaseProgressBar
            value={progress}
            total={100}
            showInfo={true}
            strokeColor={"var(--primary-1000)"}
            trailColor={"var(--neutral-200)"}
            size="small"
          />
        ) : (
          <div className="flex items-center gap-100">
            <BaseSpinner size="extra-small" />
          </div>
        )}
      </div>
    </div>
  );
};
